import RewardPointsAndBonus from './../../presentation/rewardPointsAndBonus/RewardPointsAndBonus.jsx';

const RewardPointsAndBonusContainer = ({
	recognitionPointsTotal,
	isLoading,
}) => {
	const rewardPointsBonus = { totalEarned: recognitionPointsTotal ?? 0 };

	return (
		<>
			<RewardPointsAndBonus
				isLoading={isLoading}
				rewardPointsBonus={rewardPointsBonus}
			/>
		</>
	);
};

export default RewardPointsAndBonusContainer;
